<template>
  <div>
    <HeadersDetalhesResumo
      :apelido="imovel.apelido"
      :proprietario="imovel.proprietario"
      :tipo="imovel.tipo"
      :savoynet="imovel.savoynet"
    >
    </HeadersDetalhesResumo>
    <v-layout row wrap align-center class="secondary white--text detalhes-header">
      <v-flex xs2>
        <v-container fluid class="py-2">      
          <v-layout row wrap>
            <v-flex xs12 class="text-xs-left">
              <v-btn icon :to="({ name: 'ImoveisDetalhesResumo', params: { id: $route.params.id } })" class="ma-0 white--text">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex xs8>
        <v-container fluid class="py-2">      
          <v-layout row wrap>
            <v-flex xs12>
              <span class="subtitulo">{{ componentTituloPlural }}</span>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <template v-if="observacoes.length > 0">
      <v-card flat v-for="(item, index) in observacoes" :key="item.id">
        <v-layout row wrap class="pt-2">
          <v-flex xs12 sm10 offset-sm1 md8 offset-md2>
            <v-card-text>
              <span class="grey--text">{{ item.data }} às {{ item.horario }}</span><br>
              {{ item.conteudo }}
            </v-card-text>
            <v-card-actions class="text-xs-right">
              <v-dialog v-model="dialogEditar" persistent lazy max-width="680" v-if="$hasGranularPermission('observacoes', 'edit')">
                <v-btn flat class="text-xs-right primary--text" slot="activator" @click.native="beforeEditar(item)">Editar</v-btn>
                <v-card>
                  <v-card-text>
                    <v-text-field
                      v-model="formEditar.fields.conteudo"
                      :label="componentTitulo"
                      multi-line
                      v-validate="'required'"
                      name="editar.observacao"
                      data-vv-as="observação"
                      :error-messages="errors.has('editar.observacao') ? errors.first('editar.observacao') : []"
                    >
                    </v-text-field>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="error--text" flat @click.native="descartar">Descartar</v-btn>
                    <v-btn class="secondary--text" flat @click.native="onSubmitEditar()">Salvar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogApagar" lazy max-width="520" v-if="$hasGranularPermission('observacoes', 'delete')">
                <v-btn flat class="error--text" slot="activator" @click.native="beforeApagar(item)">Apagar</v-btn>
                <v-card>
                  <v-card-title>
                    <div class="headline">Tem certeza que deseja apagar?</div>
                  </v-card-title>
                  <v-card-text>Essa ação não poderá ser desfeita.</v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="secondary--text" flat @click.native="dialogApagar = false">Descartar</v-btn>
                    <v-btn class="error--text" flat @click.native="onSubmitApagar()">Apagar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card-actions>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
      </v-card>
      <IrParaOTopo></IrParaOTopo>
    </template>
    <p class="text-xs-center mt-5 subheading" v-else>Nenhuma {{ componentTitulo.toLowerCase() }} cadastrada.</p>
    <v-dialog v-model="dialog" persistent lazy max-width="720">
      <v-btn dark fab fixed bottom right class="secondary" slot="activator" v-if="$hasGranularPermission('observacoes', 'add')">
        <v-icon>add</v-icon>
      </v-btn>
      <v-card>
        <v-card-text>
          <v-text-field
            v-model="form.fields.conteudo"
            :label="componentTitulo"
            multi-line
            v-validate="'required'"
            name="adicionar.observacao"
            data-vv-as="observação"
            :error-messages="errors.has('adicionar.observacao') ? errors.first('adicionar.observacao') : []"
          >
          </v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="error--text" flat @click.native="descartar">Descartar</v-btn>
          <v-btn class="secondary--text" flat @click.native="onSubmit">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import _ from 'lodash'
  import axios from 'axios'
  import { apiURL } from '@/config'
  import IrParaOTopo from '../../Utils/IrParaOTopo'
  import HeadersDetalhesResumo from '../Headers/HeadersDetalhesResumo'

  export default {
    components: {
      IrParaOTopo,
      HeadersDetalhesResumo
    },
    data () {
      return {
        componentVoltar: (this.$route.params.tipo === 'geral') ? 'ImoveisDetalhesResumo' : `ImoveisDetalhes${_.upperFirst(this.$route.params.tipo)}`,
        componentTitulo: (this.$route.params.tipo === 'geral') ? 'Anotação' : 'Observação',
        componentTituloPlural: (this.$route.params.tipo === 'geral') ? 'Anotações' : 'Observações',
        dialog: false,
        dialogEditar: false,
        dialogApagar: false,
        imovelId: this.$route.params.id,
        form: {
          fields: {
            tipo: this.$route.params.tipo,
            conteudo: ''
          }
        },
        formEditar: {
          fields: {
            conteudo: ''
          }
        },
        itemEditar: {},
        itemApagar: {}
      }
    },
    computed: {
      imovel () {
        return this.$store.getters['imoveis/detalhes']
      },
      observacoes () {
        return this.$store.getters['imoveis/observacoes'](this.$route.params.tipo)
      },
      isFormInvalid () {
        return Object.keys(this.fields).some(key => this.fields[key].invalid) || _.isEmpty(_.omitBy(this.form.fields, _.isEmpty))
      }
    },
    methods: {
      descartar () {
        this.dialog = false
        this.dialogEditar = false
        this.dialogApagar = false
        this.form.fields.conteudo = ''
        this.formEditar.fields.conteudo = ''
        this.errors.clear()
      },
      beforeEditar (item) {
        this.formEditar.fields.conteudo = item.conteudo
        this.itemEditar = item
      },
      beforeApagar (item) {
        this.itemApagar = item
      },
      onSubmit () {
        this.$store.dispatch('utils/showLoading')

        this.$validator.validateAll('adicionar').then((result) => {
          if (result) {
            axios.post(`${apiURL}/observacoes/${this.imovelId}`, this.form.fields).then((response) => {
              this.$store.dispatch('imoveis/loadImovel', { id: this.imovelId }).finally(() => {
                this.descartar()
                this.$store.dispatch('utils/hideLoading')
              })
            }, () => {
              this.$store.dispatch('utils/showSnackbar', {
                text: 'Servidor indisponível. Tente novamente mais tarde.'
              })
              this.$store.dispatch('utils/hideLoading')
            })
          } else {
            this.$store.dispatch('utils/showSnackbar', {
              type: 'error',
              text: 'Preencha os campos corretamente'
            })
            this.$store.dispatch('utils/hideLoading')
          }
        })
      },
      onSubmitEditar () {
        this.$store.dispatch('utils/showLoading')

        this.$validator.validateAll('editar').then((result) => {
          if (result) {
            axios.patch(`${apiURL}/observacoes/${this.itemEditar.id}`, this.formEditar.fields).then((response) => {
              this.$store.dispatch('imoveis/updateObservacao', { item: this.itemEditar, conteudo: this.formEditar.fields.conteudo })
              this.descartar()
              this.$store.dispatch('utils/hideLoading')
            }, () => {
              this.$store.dispatch('utils/showSnackbar', {
                text: 'Servidor indisponível. Tente novamente mais tarde.'
              })
              this.$store.dispatch('utils/hideLoading')
            })
          } else {
            this.$store.dispatch('utils/showSnackbar', {
              type: 'error',
              text: 'Preencha os campos corretamente'
            })
            this.$store.dispatch('utils/hideLoading')
          }
        })
      },
      onSubmitApagar () {
        axios.delete(`${apiURL}/observacoes/${this.itemApagar.id}`).then((response) => {
          this.$store.dispatch('imoveis/deleteObservacao', this.itemApagar)
          this.descartar()
          this.$store.dispatch('utils/hideLoading')
        }, () => {
          this.$store.dispatch('utils/showSnackbar', {
            text: 'Servidor indisponível. Tente novamente mais tarde.'
          })
          this.$store.dispatch('utils/hideLoading')
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// DetalhesObservacoes.vue?5a578d8b